export default [{
        url: '/overview',
        name: 'Overview',
        icon: 'cloud_queue'
    },
    {
        url: '/report',
        name: 'Report',
        icon: 'description'
    },
    {
        url: '/map',
        name: 'Map',
        icon: 'map'
    },
    {
        url: '/dashboard',
        name: 'Dashboard',
        icon: 'dashboard'
    },
    {
        url: '/location',
        name: 'Location',
        icon: 'room'
    },
    {
        url: '/indoortracking',
        name: 'Indoor Tracking',
        icon: 'compass_calibration'
    },
    {
        url: '/sensor',
        name: 'Sensor',
        icon: 'signal_cellular_alt'
    },
    {
        url: '/gateway',
        name: 'Gateway',
        icon: 'router'
    },
    {
        url: '/Alert',
        name: 'Alert',
        icon: 'report_problem'
    },
    // {
    //     url: "/camera",
    //     name: "Camera",
    //     icon: "photo_camera"
    // },

    {
        url: '/workorder',
        name: 'Work Management',
        icon: 'work'
    },
    {
        url: '/WorkRequests',
        name: 'Work Request',
        icon: 'work'
    },
    // {
    // 	url: "/workstatus",
    // 	name: "Work Status",
    // 	icon: "assignment"
    // },
    {
        url: '/action',
        name: 'Alert Setting',
        icon: 'new_releases'
    },
    {
        url: '/network',
        name: 'Network',
        icon: 'wifi'
    },
    {
        url: '/user',
        name: 'User',
        icon: 'person'
    },
    {
        url: '/locationsetting',
        name: 'Location Setting',
        icon: 'explore'
    },
    {
        url: '/permission',
        name: 'Permission Setting',
        icon: 'how_to_reg'
    },
    // {
    // 	url: "/setting",
    // 	name: "Setting",
    // 	icon: "settings"
    // },
    {
        url: '/form',
        name: 'Form',
        icon: 'insert_drive_file'
    },
    {
        url: '/SetupWorkRequests',
        name: 'Setup Work Requests',
        icon: 'work'
    }
]